const translations: Record<string, string> = {
  "ak_sld_normal": "Normal",
  "ak_sld_warning": "Warning",
  "ak_sld_alarm": "Alarm",
  "ak_sld_no_link": "No link",
  "ak_sld_generating": "Generating",
  "ak_sld_online_not_generating": "Online, not generating",
  "ak_sld_temporary_link_loss": "Temporary link loss",
  "ak_sld_running": "Running",
  "ak_sld_online": "Online",
  "ak_sld_min_ago": "{{n}} min ago",
  "ak_sld_h_min_ago": "{{h}} h {{m}} min ago",
  "ak_sld_no_link_last_data_at": "no link · last data at {{c}}",
  "ak_sld_data_is_stale_received": "data is stale · received {{a}}",
  "ak_sld_alarm_2": "alarm “{{s}}”",
  "ak_sld_the_device_reported_an_alarm": "the device reported an alarm “{{s}}”",
  "ak_sld_code": " (code {{c}})",
  "ak_sld_data_quality": "data quality “{{q}}”",
  "ak_sld_the_collector_flagged_data_quality_ins": "the collector flagged data quality “{{q}}” instead of “ok”",
  "ak_sld_unknown_status": "unknown status “{{s}}”",
  "ak_sld_the_device_reported_an_unknown_status": "the device reported an unknown status “{{s}}”",
  "ak_sld_alarm_3": "alarm{{s}}",
  "ak_sld_the_pcs_reported_an_active_alarm": "The PCS reported an active alarm",
  "ak_sld_the_device_reported_an_alarm_2": "the device reported an alarm{{s}}",
  "ak_sld_status": " · status{{s}}",
  "ak_sld_more": " · {{n}} more",
  "ak_sld_loading_data": "loading data…",
  "ak_sld_no_data_from_the_telemetry_server": "no data from the telemetry server",
  "ak_sld_more_2": "{{n}} more",
  "ak_sld_kw": "kW",
  "ak_sld_mw": "MW",
  "ak_sld_hz": "Hz",
  "ak_sld_mwh": "MWh",
  "ak_sld_mv": "mV",
  "ak_sld_v": "V",
  "ak_sld_a": "A",
  "ak_sld_h": "h",
  "ak_sld_of_nominal": "of nominal",
  "ak_sld_online_2": "online",
  "ak_sld_bess": "BESS · {{m}}",
  "ak_sld_racks_group": "Racks {{r}} · Group {{g}}",
  "ak_sld_soc_vs_group": "ΔSoC vs Group {{g}}",
  "ak_sld_group": "Group {{g}}",
  "ak_sld_group_2": "{{p}} · Group {{g}}",
  "ak_sld_p_estimate": "P · estimate · {{d}}",
  "ak_sld_measurement": "Measurement:",
  "ak_sld_banks_racks": " · {{n}} × {{v}} {{s}} · {{b}} {{bv}} banks · {{r}} racks",
  "ak_sld_ktp_inverters_panels": " · {{n}} KTP · {{i}} {{v}} {{m}} inverters · panels {{p}}",
  "ak_sld_banks": "Banks",
  "ak_sld_racks": "racks",
  "ak_sld_racks_2": "Racks",
  "ak_sld_from_pcs": "from PCS",
  "ak_sld_transformer": "Transformer",
  "ak_sld_inverters": "{{n}} {{v}} {{m}} inverters · {{r}}",
  "ak_sld_group_3": "Group",
  "ak_sld_logger_plc_channel_plc_channel_number": "{{c}} - logger PLC channel; {{p}} - PLC channel number",
  "ak_sld_channel": "Channel",
  "ak_sld_breakers": "Breakers",
  "ak_sld_inverter": "Inverter {{p}}, {{s}}",
  "ak_sld_not_in_the_logger_poll": "not in the logger poll",
  "ak_sld_the_inverter_is_not_in_the_last_logger": "the inverter is not in the last logger poll",
  "ak_sld_no_link_2": "no link",
  "ak_sld_data_is_stale": "data is stale",
  "ak_sld_data_quality_idle_in_daytime": "data quality “idle” in daytime",
  "ak_sld_the_collector_flagged_data_quality_idl": "the collector flagged data quality “idle” although the station is generating",
  "ak_sld_not_in_the_poll": "not in the poll",
  "ak_sld_the_pcs_is_not_in_the_last_bess_poll": "the PCS is not in the last BESS poll",
  "ak_sld_hover_over_a_device": "hover over a device",
  "ak_sld_no_deviations": "No deviations",
  "ak_sld_no_data": "no data",
  "ak_sld_just_now": "just now",
  "ak_sld_discharge": "Discharge",
  "ak_sld_charge": "Charge",
  "ak_sld_stopped": "Stopped",
  "ak_sld_standby": "Standby",
  "ak_sld_inv": "inv.",
  "ak_sld_dev": "dev.",
  "ak_sld_point_of_connection": "Point of connection",
  "ak_sld_estimate": "estimate",
  "ak_sld_reason": "Reason",
  "ak_sld_pv_plant_sum_of_inverters": "PV plant (sum of inverters)",
  "ak_sld_inverter_data": "Inverter data",
  "ak_sld_bess_data": "BESS data",
  "ak_sld_can_discharge": "Can discharge",
  "ak_sld_can_charge": "Can charge",
  "ak_sld_to_full_discharge": "To full discharge",
  "ak_sld_to_full_charge": "To full charge",
  "ak_sld_cell_temperature_max": "Cell temperature, max.",
  "ak_sld_data": "Data",
  "ak_sld_mode": "Mode",
  "ak_sld_power": "Power",
  "ak_sld_load": "Load",
  "ak_sld_temperature": "Temperature",
  "ak_sld_allowed_charge_discharge": "Allowed charge / discharge",
  "ak_sld_device_status": "Device status",
  "ak_sld_logger_data": "Logger data",
  "ak_sld_frequency": "Frequency",
  "ak_sld_ac_power": "AC power",
  "ak_sld_dc_power": "DC power",
  "ak_sld_of_nominal_2": "% of nominal",
  "ak_sld_deviations": "Deviations",
  "ak_sld_none": "none",
  "ak_sld_soc_between_groups": "ΔSoC between groups",
  "ak_sld_cell_temperature": "Cell temperature",
  "ak_sld_cell_voltage": "Cell voltage",
  "ak_sld_voltage_current": "Voltage / current",
  "ak_sld_the_power_at_the_point_of_connection_s": "The power at the point of connection should be measured by the DIRIS A-30; the cabinet does not poll it yet - this is an estimate without losses and auxiliary consumption.",
  "ak_sld_export": "export",
  "ak_sld_import": "import",
  "ak_sld_point_of_connection_pcc": "Point of connection (PCC)",
  "ak_sld_limit": "Limit",
  "ak_sld_frequency_inverters": "Frequency · inverters",
  "ak_sld_energy_storage_bess": "Energy storage (BESS)",
  "ak_sld_solar_generation": "Solar generation",
};

export default translations;
